import {
  STATUS_CHIP_FONT_FAMILY,
  STATUS_CHIP_FONT_SIZE_PX,
  STATUS_CHIP_FONT_WEIGHT,
  STATUS_CHIP_PADDING_X_PX,
} from './StatusChip.styles';

const CELL_PADDING_X_PX = 12;
const ROUNDING_ALLOWANCE_PX = 4;
const FALLBACK_CHAR_WIDTH_PX = 8;

const capitalizeWords = (label: string): string =>
  label.replace(/\b\p{L}/gu, (letter) => letter.toUpperCase());

const measureLabel = (label: string): number => {
  const context = document.createElement('canvas').getContext('2d');
  if (!context) return label.length * FALLBACK_CHAR_WIDTH_PX;
  context.font = `${STATUS_CHIP_FONT_WEIGHT} ${STATUS_CHIP_FONT_SIZE_PX}px "${STATUS_CHIP_FONT_FAMILY}", sans-serif`;
  return context.measureText(capitalizeWords(label)).width;
};

export const getStatusChipColumnWidth = (labels: string[], minWidth: number): number =>
  Math.max(
    minWidth,
    ...labels.map((label) =>
      Math.ceil(
        measureLabel(label) +
          2 * STATUS_CHIP_PADDING_X_PX +
          2 * CELL_PADDING_X_PX +
          ROUNDING_ALLOWANCE_PX,
      ),
    ),
  );
